<template>
  <div class="only-list" :class="[item.defaultBool?'default-list':'']"  @mouseleave="leaveFun(className)">
    <div class="loading">
      <div class="loading-div">
        <template v-if="lazy.bool">
          <div :class="[lazy.elementClass]" :data-background="item.imgSrc||'./static/images/default524.jpg'"></div>
        </template>
        <template v-else>
          <div :style="backgroundImage"></div>
        </template>
      </div>
      <img :src="lazy.loading" alt="">
    </div>
    <div class="swiper-cover">
      <div class="only-list-code only-list-code-hide">
        <div class="code-content"><div :id="className" style="width: 100%;height: 100%;"></div></div>
      </div>
      <template v-if="item.panoUrl">
        <a class="see-pan-url" :href="item.panoUrl" target="_blank"></a>
        <span class="icon-img see-pan"></span>
      </template>
      <template v-else>
        <!--<a class="see-pan-url" href="javascript:void(0);"></a>-->
      </template>
      <share class="only-swiper-share" :share="item.share" :good="item.good"></share>
      <div class="identification">
        {{state==2?item.cityBool?'城市名片':'推荐':item.cityName}}
      </div>
      <div class="name">
        <div class="name-title">
          <div>
            <h3 class="twoRow">{{item.name}}</h3>
            <template v-if="item.panoUrl">
              <template v-if="loop">
                <i class="icon-img icon-qr"></i>
              </template>
              <template v-else>
                <i class="icon-img icon-qr" @mouseenter="searchEnter(className)"></i>
              </template>
            </template>
            <!---->
          </div>
        </div>
        <p class="oneRow">{{item.eng}}</p>
      </div>
      <div class="swiper-info">
        <div v-if="item.address" class="">
          <span class="icon-img icon-address icon-address-white"></span>
          <p class="oneRow" :title="item.address">{{item.address}}</p>
        </div>
        <div v-if="item.phone" class="phone">
          <span class="icon-img icon-phone icon-phone-white"></span>
          <p>{{item.phone}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import share from '@/components/share'
export default {
  props: ['item', 'lazy', 'hover', 'index', 'state', 'className', 'loop'],
  name: 'onlyList',
  data () {
    return {
      backgroundImage: {
        backgroundImage: ''
      },
      seating: './static/images/icon/loading2.png',
      qrBool: true,
      mathCeil: Math.ceil(Math.random() * 100)
    }
  },
  components: {
    share: share
  },
  created () {
  },
  mounted () {
    let that = this
    that.backgroundImage.backgroundImage = 'url(' + (that.item.imgSrc || './static/images/default524.jpg') + ')'
  },
  methods: {
    leaveFun: function (className) {
      this.publicJs.qrCode(className, false)
    },
    searchEnter: function (className) {
      this.qrBool = false
      this.publicJs.qrCode(className, true)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .only-list{
    position: relative;
  }
  .only-list,.loading,.loading-div{
    width: 100%;
    height: 100%;
  }
  .swiper-cover{
    position: absolute;
    top:0;
    right: 0;
    bottom: 0;
    left: 0;
    /*background-color: rgba(0, 0, 0, 0.18);*/
    z-index: 5;
    color: #fff;
  }
  .swiper-slide-active .swiper-cover{
    z-index: 7;
  }
  .loading-div>div::after{
    background-color: rgba(0,0,0,0.18);
  }
  .swiper2 .swiper-slide>div::after{
    background-color: rgba(0,0,0,0.3);
    content: '';
    position: absolute;
    top:0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 6;
  }
  .swiper2 .see-pan{
    -webkit-transform: scale(0.7);
    -moz-transform: scale(0.7);
    -ms-transform: scale(0.7);
    -o-transform: scale(0.7);
    transform: scale(0.7);
    top:15%;
  }
  .swiper2 .swiper-slide-active>div::after{
    background-color: inherit;
  }
  .identification{
    position: absolute;
    top:0;
    left: 0;
    z-index: 4;
    background: #F6BC32;
    border-bottom-right-radius:34px;
    padding: 8px 28px 8px 16px;
  }
  .hover .see-pan:after,
  .swiper .swiper-slide-active .see-pan::after{
    -webkit-animation: zoomIn 1.2s 10;
    -o-animation: zoomIn 1.2s 10;
    animation: zoomIn 1.2s 10;
  }
  .see-pan{
    position: absolute;
    top:58px;
    right: 38px;
    width: 82px;
    height: 64px;
    display: none;
  }
  .see-pan-url{
    position: absolute;
    top:0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 1;
  }
  .name-title{
    max-width: 300px;
    font-size: 24px;
    font-weight: 500;
    color: #fff;
    margin-bottom: 19px;
    text-align: left;
    line-height: 30px;
    height: 60px;
  }
  .name-title>div{
    display: inline-block;
    padding-right: 30px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    position: relative;
  }
  .name-title i{
    width: 24px;
    height: 24px;
    position: absolute;
    right: 0;
    top:4px;
    background-position:-740px -290px;
  }
  p{
    width: 300px;
    font-size: 14px;
    line-height: 1;
    font-weight: 500;
    color: #fff;
    text-align: left;
  }
  .name{
    position: absolute;
    top:58px;
    left: 15px;
    z-index: 2;
  }
  .name>p{
    width: 320px;
    font-size: 14px;
    font-weight: 500
  }
  .swiper-info{
    position: absolute;
    bottom: 16px;
    left: 15px;
    z-index: 2;
  }
  .swiper-info>div{
    position: relative;
    padding: 2px 0 2px 24px;
  }
  .phone{
    margin-top: 13px;
  }
  .swiper-info .icon-img{
    position: absolute;
    left: 0;
    top:0;
    background-size: 650px;
  }
  .icon-phone-white{
    background-position:-107px -242px;
  }
  .icon-address-white{
    background-position:-108px -330px;
  }
  .swiper-info .icon-phone{
    top:0;
  }
  .phone p{
    width: 160px;
  }
  .only-swiper-share{
    position: absolute;
    right:14px;
    bottom:14px;
    z-index: 4;
    color: white;
  }
  .hover .loading-div>div{
    -webkit-transform: scale(1.2);
    -moz-transform: scale(1.2);
    -ms-transform: scale(1.2);
    -o-transform: scale(1.2);
    transform: scale(1.2);
    -webkit-transition: transform 0.5s;
    -moz-transition: transform 0.5s;
    -ms-transition: transform 0.5s;
    -o-transition: transform 0.5s;
    transition: transform 0.5s;
  }

  .hover .only-swiper-share{
    font-size: 18px;
  }
  .hover .name-title{
    max-width: 345px;
    font-size: 28px;
    line-height: 35px;
    height: 90px;
  }
  .hover .name-title>div{
    padding-right: 32px;
  }
  .hover .name-title i{
    top:5px;
    width: 28px;
    height: 28px;
    background-position:-692px -288px;
  }
  .hover p{
    font-size: 18px;
  }
  .hover .see-pan, .swiper2 .see-pan{
    display: block;
  }
  .hover .name>p{
    font-size: 16px;
  }
  .hover .icon-img{
    background-size:815px;
  }

  .hover .icon-phone-white{
    width: 20px;
    height: 20px;
    background-position:-136px -305px
  }
  .hover .icon-address-white{
    width: 16px;
    height: 21px;
    background-position:-138px -414px;
  }
  .screen2 .see-pan{
    -webkit-transform: scale(0.8);
    -moz-transform: scale(0.8);
    -ms-transform: scale(0.8);
    -o-transform: scale(0.8);
    transform: scale(0.8);
  }
  .screen2 .hover .name-title{
    max-width: 300px;
  }
  .screen2 .see-pan{
    right: 10px;
  }
  .default-list .icon-qr,.default-list .see-pan{
    display: none;
  }
  .default-list .loading-div>div{
  }
</style>



// WEBPACK FOOTER //
// src/components/swiperList1.vue